import React from "react";
import { PageCrop } from "./PageCrop";
import { Daisy } from "./decor/Daisy";
import { LeafSprig } from "./decor/LeafSprig";
import { brandAssets } from "../data/offer";
import { heroFanPages, parablePages } from "../data/landing";
const placements = ["left-[2%] top-[9%] w-[41%] -rotate-[8deg]", "left-[28%] top-0 z-10 w-[44%]", "right-[2%] top-[9%] w-[41%] rotate-[8deg]"];
function titleFor(x: number) {
  return parablePages.find(p => p.x === x)?.title ?? "Parabole";
}

// Composition « collection » avec de vraies pages du Méga Pack et le logo officiel.
export function PageFan({
  showTagline = true
}: {
  showTagline?: boolean;
}) {
  return <div className="relative mx-auto w-full max-w-[540px]" data-id="element-193" data-mp="yfbh1rrmxwbg">
      <div className="relative aspect-[5/4]" data-id="element-194" data-mp="tjw4r49a08h5">
        {heroFanPages.map((x, i) => <div key={x} className={`absolute overflow-hidden rounded-2xl border-4 border-white shadow-[0_10px_30px_rgba(90,58,34,0.18)] ${placements[i]}`} data-id="element-195" data-mp="oif5teacqw37" data-mpi={i}>
            <PageCrop x={x} title={titleFor(x)} data-id="element-196" data-mp="spexme6s9xsp" />
          </div>)}
        <img src={brandAssets.logo} alt="Logo Petites Histoires, Grande Foi" className="absolute -bottom-[8%] -left-[3%] z-20 w-[33%] drop-shadow-[0_8px_16px_rgba(90,58,34,0.25)]" data-id="element-197" data-mp="xg53rtn1a4og" />
        <LeafSprig className="absolute -right-2 -top-4 z-0 w-14 md:w-16" data-id="element-198" data-mp="npu08879hxi3" />
        <Daisy className="absolute -top-3 left-[24%] z-20 w-8 md:w-9" data-id="element-199" data-mp="1bg6es1x0ishn" />
        <Daisy className="absolute bottom-[4%] right-[6%] z-20 w-7" data-id="element-200" data-mp="1be3gkulpht1u" />
      </div>
      {showTagline && <p className="relative z-20 mx-auto mt-10 w-fit rounded-full border-2 border-sun bg-cream px-5 py-1.5 text-center font-display text-sm font-semibold text-cocoa md:text-base" data-id="element-201" data-mp="1gd6k2am1fr7p">
          {brandAssets.tagline}
        </p>}
    </div>;
}